export default __webpack_public_path__ + "static/media/dev.52c6db5b.svg";